import React from 'react'
import { Link } from 'react-router-dom'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import Seo from '../components/Seo'
import ServiceCard from '../components/ServiceCard'
import PlatformCard from '../components/PlatformCard'
import { services } from '../data/services'
import { company } from '../data/company'
import './home.css'

const Home = () => {
  return (
    <div className="page">
      <Seo
        path="/"
        description="Konsri Technologies builds FinQ — WhatsApp stock alerts for NSE & BSE — and offers product development, software, cloud, and data services."
      />
      <Navbar />

      <header className="hero-band home-hero">
        <div className="container">
          <div className="home-hero__copy">
            <p className="home-hero__eyebrow">{company.shortName}</p>
            <h1 className="home-hero__title">
              We build products that ship — and services that keep them running
            </h1>
            <p className="home-hero__subtitle">
              Home of FinQ, our WhatsApp stock-alert platform for Indian markets. When you need more
              than a product, we partner on engineering, cloud, and data.
            </p>
            <div className="home-hero__actions">
              <a href="#platform" className="btn btn-primary">
                Explore FinQ
              </a>
              <Link to="/services" className="btn btn-secondary">
                Our Services
              </Link>
            </div>
          </div>
        </div>
      </header>

      <section className="section platform-section" id="platform">
        <div className="container">
          <PlatformCard />
        </div>
      </section>

      <section className="section services-section" id="services">
        <div className="container">
          <h2 className="section-heading">Our Services</h2>
          <p className="section-lead">
            Practical engineering help for teams that want to move faster — without the buzzwords.
          </p>
          <div className="services-grid">
            {services.map((service) => (
              <ServiceCard key={service.id} service={service} />
            ))}
          </div>
          <div className="services-section__more">
            <Link to="/services" className="btn btn-outline">
              View service details
            </Link>
          </div>
        </div>
      </section>

      <section className="section about-section" id="about">
        <div className="container about-inner">
          <h2 className="section-heading">About Us</h2>
          <p className="about-desc">
            Konsri Technologies is a product company. We build and operate FinQ, and we take on
            selected consulting and engineering work across product development, software, cloud,
            and data — the same disciplines we use to run our own platform.
          </p>
        </div>
      </section>

      <section className="section contact-section" id="contact">
        <div className="container contact-inner">
          <h2 className="section-heading">Contact</h2>
          <p className="section-lead">
            Questions about FinQ or a services engagement? Reach us directly.
          </p>
          <a href={`mailto:${company.email}`} className="btn btn-primary contact-cta">
            {company.email}
          </a>
          <p className="contact-legal">
            {company.legalName}
            <br />
            CIN: {company.cin}
          </p>
        </div>
      </section>

      <Footer />
    </div>
  )
}

export default Home
